module.exports = __webpack_public_path__ + "img/accountxc-logo.223dc0c0.png";